export default __webpack_public_path__ + "static/media/templatePicture.12882a9c.png";